export interface ReleaseMovementContext {
  isEmbed: boolean;
  isBpmSession: boolean;
  isTslhSession: boolean;
  countFreeAgentSignings: boolean;
  signingsUsed: number;
  signingsMax: number;
}

export function isReleaseBlockedByMovementLimit(ctx: ReleaseMovementContext): boolean {
  if (!ctx.isEmbed || !(ctx.isBpmSession || ctx.isTslhSession)) return false;
  if (!ctx.countFreeAgentSignings) return false;
  return ctx.signingsMax <= 0 || ctx.signingsUsed >= ctx.signingsMax;
}
